<template>
  <ParseForm :formParams='formParams' :emit='emit' formId='dataBusiness' :opCode='opCode' :funcKeyUp='bindKeyUpInterface' ref='bus'></ParseForm>
</template>

<script>
import ParseForm from '../../util/parseFormNew/ParseForm';
import commonJS from '../common';
import bus from './bus';

export default {
  name: 'U_BaseBusiness',
  components: {
    ParseForm
  },
  mixins: [commonJS],
  props: [
    'formParams',
    'opCode'
  ],
  data() {
    return {
      funcMap: '',
      funcKeyUpMap: '',
    };
  },
  methods: {
    getDatas() {
      return this.$refs.bus.getDatas();
    },

    setData(_name, _data) {
      this.$refs.bus.setData(_name, _data);
    },

    validateResult() {
      return this.$refs.bus.validateResult();
    },

    passwordBindKeyUpFunc(origin, confirm) {
      const $this = this;
      $this.funcKeyUpMap.set(origin, () => {
        const originValue = $this.$refs.bus.getAttrByName(origin, 'value');
        const confirmValue = $this.$refs.bus.getAttrByName(confirm, 'value');
        let newRule = {};
        if (originValue === confirmValue) {
          newRule = {
            required: [true, this.$t('MCS.require')],
            rangeLength: [[0, 63], this.$t('MCS.numAt63')],
            number: [true, this.$t('MCS.insertNum')],
          };
        } else {
          newRule = {
            required: [true, this.$t('MCS.require')],
            rangeLength: [[0, 63], this.$t('MCS.numAt63')],
            number: [true, this.$t('MCS.insertNum')],
            regex: [this.regex.noMatchRegex, this.$t('MCS.passwordEqual')]
          };
        }
        $this.$refs.bus.removeValidate(origin);
        $this.$refs.bus.removeValidate(confirm);
        $this.$refs.bus.setValidate(origin, newRule);
        $this.$refs.bus.setValidate(confirm, newRule);
        $this.$refs.bus.validateResult(['password[origin]', 'password[confirm]']);
      });
      $this.funcKeyUpMap.set(confirm, () => {
        const originValue = $this.$refs.bus.getAttrByName(origin, 'value');
        const confirmValue = $this.$refs.bus.getAttrByName(confirm, 'value');
        let newRule = {};
        if (originValue === confirmValue) {
          newRule = {
            required: [true, this.$t('MCS.require')],
            rangeLength: [[0, 63], this.$t('MCS.numAt63')],
            number: [true, this.$t('MCS.insertNum')],
          };
        } else {
          newRule = {
            required: [true, this.$t('MCS.require')],
            rangeLength: [[0, 63], this.$t('MCS.numAt63')],
            number: [true, this.$t('MCS.insertNum')],
            regex: [this.regex.noMatchRegex, this.$t('MCS.passwordEqual')]
          };
        }
        $this.$refs.bus.removeValidate(origin);
        $this.$refs.bus.removeValidate(confirm);
        $this.$refs.bus.setValidate(origin, newRule);
        $this.$refs.bus.setValidate(confirm, newRule);
        $this.$refs.bus.validateResult(['password[origin]', 'password[confirm]']);
      });
    },

    bindUtf8CodeLengthRegex(name, maxLength) {
      const $this = this;
      this.funcKeyUpMap.set(name, () => {
        const _rule = {
          regex: [$this.regex.char, $this.$t('MCS.noSpecialChar')]
        };
        $this.$refs.bus.removeValidate(name);
        $this.$refs.bus.setValidate(name, _rule);
        if ($this.$refs.bus.validateResult([name]) === true) {
          if ($this.utf8Length($this.$refs.bus.getDatas().get(name), maxLength) === false) {
            const _utf8Rule = {
              regex: [$this.regex.noMatchRegex, this.$t('MCS.charAt63')]
            };
            $this.$refs.bus.removeValidate(name);
            $this.$refs.bus.setValidate(name, _utf8Rule);
          }
        }
      });
    },

    emit(attr) {
      bus.$emit('eventBus', attr);
    },

  },
  computed: {
    bindKeyUpInterface() {
      this.funcKeyUpMap = new Map();
      this.passwordBindKeyUpFunc('password[origin]', 'password[confirm]');
      this.bindUtf8CodeLengthRegex('mcptt_userAlias', 63);
      return this.funcKeyUpMap;
    },
  },
  mounted() {
    bus.$on('eventBus', (attr) => {
      try {
        this.$refs.bus.templetCover(attr);
      } catch (e) {
      }
    });
  }
};
</script>

<style scoped>

</style>
